import { CognitoTokenManager } from 'app/modules/auth/utils/cognitoTokenManager';

/**
 * [POST-WORKFLOW GATE — TEMPORARY] Accounts that use the NEW editorial post-workflow API.
 *
 * Add an account id (with a comment naming the account) to roll the new workflow out to it;
 * remove it to put the account back on the legacy endpoints. Every account NOT listed here
 * keeps the current production behaviour.
 *
 * Keep this list in sync with the BE `POST_WORKFLOW_NEW_API_ACCOUNT_IDS` secret for the same
 * environment — if the FE calls the new endpoints while the BE has not allowlisted the account,
 * the BE answers 403. Changing this list requires a rebuild + deploy (it is baked into the bundle).
 *
 * Remove this file together with the gate once every account is cut over.
 */
export const POST_WORKFLOW_NEW_API_ACCOUNT_IDS: readonly number[] = [
  // Dev environments (these ids exist only on dev, never on production)
  2, // dev1
  3, // dev2
  // 4, // dev3
  5, // dev4
  6, // dev5
  // 16, // dev6
  43, // dev9

  // Internal production accounts used for testing (all @kontentino.com owners)
  4559, // kontentino2 — users@kontentino.com
  10810, // kontentinoapp — appmanager@kontentino.com
  25589, // eva — eva@kontentino.com
  50176, // denys.yefimenko@kontentino.com
  51032, // istvan.csemi@kontentino.com
  63745, // tests-automation

  // Beta cohort — Starter (active, paying, used in last 90 days)
  1263, // flowmedia
  2237, // specialtymedia
  7856, // moonraker
  9845, // sagesocial
  11519, // hotelridderkerk
  11647, // digicary
  12670, // eijffinger
  15435, // ac-chaumont-gistoux
  18058, // beaphar
  20409, // prahamarketing
  22948, // dinoo
  24223, // pasbv
  24642, // numberone
  24978, // advertised
  25209, // habicom2
  26608, // dataapex
  26817, // frewitt
  26837, // lamontmarketing
  27102, // sfaa
  27830, // viiruz
  28527, // spavilnius
  30020, // sitovka
  30170, // rebelation
  32588, // olimincicova
  32695, // cristalmedia
  34054, // fundamentallmedia
  34356, // fondee
  34942, // advipro
  36757, // volz
  36857, // datafriends
  37069, // localhost
  37240, // ecomailcz
  37327, // wec
  37407, // elindus
  37428, // skbeveren
  37734, // jtrelondon
  37821, // benrgroep
  37937, // kvetyvictor
  38731, // ygo
  39069, // hsp-vlaanderen
  39519, // netproductioncz
  40541, // narrabu
  41230, // edptraining
  41477, // massimmovillabouw
  41948, // stebby
  41949, // zwembadjaspers
  42421, // inprveritas
  42479, // eggentaltourismusgen
  42685, // ljekarnapablo
  42756, // insity
  42908, // greeng
  43020, // studiokampa
  43031, // gdwsecurity
  43393, // eurocommerce
  43428, // dstwebdesign
  43584, // essers-corporate
  43651, // basil
  43895, // romanrestaurants
  44176, // xve
  45606, // bpimaging
  45671, // grandhotelpupp
  45827, // danielagajdacova
  46281, // ambusiness
  46675, // victorytravel
  46685, // vivasara
  46731, // acersa
  46790, // bervin
  47495, // markandthing
  47825, // pichler-projects
  47916, // eurotrol
  47923, // emilefoundation
  47934, // varistar
  48123, // gyongyhugg
  48243, // heideberg
  48855, // takeoff
  48936, // tksotsiaalmeedia
  48964, // outpostoverseas
  49208, // bobdo
  49270, // lashkontentino
  49313, // voc
  49329, // burneys
  49397, // ergosleep
  49891, // ecococon
  49908, // fontenay-aux-roses
  49951, // terezkaaaa
  50215, // milkman
  50427, // btym
  50550, // silnerecimarketing
  50584, // petraska
  50626, // meditech
  50645, // katja-geisler
  50750, // veesla
  50800, // webagenturwinter
  51135, // tabasco
  51467, // innovationweek
  51475, // kidocentrum
  51987, // wijckmans
  52103, // vincentverhaert
  52468, // lcmproductions
  52557, // inspirimate
  52748, // b1c
  53115, // designjuice
  53237, // zeldazorro
  53512, // kpm
  53546, // advertivo
  53663, // marketingfleurop
  53813, // savannahgeluykens
  53872, // greencorner
  54505, // centralcontent
  54526, // lv-fashion
  54574, // bureaubrutale
  54678, // wastewarriors
  54721, // mathieuclairet
  54906, // powerofco
  54946, // simonabrejkova
  54976, // fixpuffin
  55185, // masterevents
  55195, // haagschcollege
  55862, // futurn
  56135, // sinjoormakelaars
  56368, // real-oat-arts
  56502, // xennacreativestudio
  56580, // createamagency
  56739, // ad-assist
  57585, // sageroom
  58085, // vanhyftewonen
  58114, // caribbeancurrents25
  58177, // improvizuj
  58192, // tracinginmotion
  58271, // yggne
  58333, // solidway
  58365, // bluesystem
  58614, // evoq-agency
  58638, // roam
  58710, // textschmiede
  58726, // dli-nl
  59094, // thesocial12
  59126, // houseofrezac
  59247, // fyrco
  59418, // klararott
  59426, // lansingunitra1873
  59656, // ratatouillefm
  59844, // northest
  59944, // vilniausduona
  59981, // jeremybuyle
  60033, // theadband
  60151, // roadtorally
  60292, // bloomlab
  60517, // ncm
  60577, // gubernija
  60588, // molyvco
  60638, // livingblue
  60712, // evaschouten
  60740, // herrys
  60746, // raadhuis
  60849, // philipswater
  60879, // cancun-adventure
  61109, // chia-vanderhoeven
  61160, // ben4x
  62176, // grindershouse
  62373, // tulea
  62989, // schaakmat
  63050, // flanderstaxshelter
  63146, // slimakslimak
  63174, // harvestcare
  63315, // finszterviki
  63693, // sleepking
  68149, // viesmilibasmarketings
  68186, // alusense
  68222, // webandgrow
  68249, // eggokeukens
  68272, // dethuisverpleegster
  68400, // phc
  68534, // dollerstudio
  68846, // vilniauspaukstynas
  68992, // pprazakova
  69426, // mile

  // Beta cohort — Starter + (active, paying, used in last 90 days)
  690, // adcommspl
  9581, // grinspire
  12082, // pointbarre
  12301, // bespoken
  13116, // medacentral
  22038, // neifund
  22267, // znconsulting
  22355, // lijncom
  25398, // trendis
  25417, // fakturoid
  25510, // yoin
  26759, // selection
  27006, // ghcgenetics
  28152, // onlimited
  28956, // fiitstu
  29060, // groupvandamme
  31196, // b1gtr33s
  32231, // rmdy
  33623, // aqtor
  37822, // grayling
  40442, // ftm-ballaerosol
  42913, // storystudio
  43811, // pavla
  43823, // mohawkgroupemea
  45462, // brandma
  45721, // digitalkingdom
  47464, // pagnos
  48437, // buildmysocial
  48577, // mateco-statech
  48723, // dmc
  49008, // logio
  49323, // premium
  49585, // konverto-marketing
  49624, // vanderstraaten
  49632, // nepagency
  49656, // ppacontroll
  49658, // irene
  49703, // wijnegemsee
  49720, // stromtalente
  50501, // vw-magyarorszag
  50516, // axabee
  50648, // vaslekar
  50727, // spoluzivot
  50741, // debrabandere
  51472, // plasmatreat
  51944, // bricodepotdigital
  52264, // admanagementrd
  52435, // yappa
  52476, // gkb
  52872, // edyta
  52932, // rylko
  53109, // azuri-group
  53601, // economischhuis
  53919, // healthplus
  54911, // risolto
  56053, // tomasgrec
  56297, // uregni
  56645, // lowin
  56966, // marketingova
  57425, // lashespro
  57520, // nicolaec
  57893, // iki
  58181, // semilacexport
  58288, // mollner
  58424, // adalesniaknoyo
  59384, // ma-studio
  59543, // leadtoday
  59805, // nidusbalticus
  59886, // bonafarm
  59945, // eurokos
  59957, // digioam
  60072, // gabari-agency
  60788, // plusgse
  60919, // affideaspain
  61682, // yogiyousef
  61736, // mybestcare
  61860, // ceskyvesmir
  61912, // blackcod
  62161, // teamanglet
  63226, // luminor
  63344, // slaapadvies
  68636, // ondrabartos3

  // Round-1 beta accounts, kept enabled (outside the 90-day activity window)
  4201, // ackee
  4453, // plugo
  10226, // netsuccess
  22995, // thinktomorrow
  26079, // labasadvertising
  29553, // lessismore
  31645, // mullenlowewarsaw
  36301, // forget-me-not
  40167, // almanacxalcronprague
  40647, // embocaps
  43154, // ebmgroup2024
  47152, // dynobend
  50825, // vekra
  51184, // bravehearts
  52847, // smagency
  53884, // basket
  54169, // elem6
  56011, // arseusmedical
  56540, // bbraunczsk
  57402, // ictech
  57896, // adheads
  58549, // caraplasma
  60100, // jumat
  62782, // hotelzuidgenk
  63197, // levipartyrental
  68886, // redbuttonedu

  // Added on request by CS, outside the Starter cohorts
  38747, // socially — Pro plan, needs the new workflow for a pending support case
];

/**
 * [POST-WORKFLOW GATE — TEMPORARY] When true, the new post-workflow is enabled for EVERY
 * account (full cutover) without listing ids; false falls back to the allowlist above.
 *
 * FULL CUTOVER — every account now uses the new post-workflow API, so the allowlist above
 * is no longer consulted. It is kept (rather than deleted) only so this flip stays a
 * one-line revert; both go away with the rest of the gate.
 *
 * Requires the BE to be on `POST_WORKFLOW_API=new` with
 * `POST_WORKFLOW_NEW_API_ACCOUNT_IDS=*` FIRST — the new endpoints sit behind the
 * `post_workflow_new` middleware and answer 403 to accounts the BE has not allowlisted.
 */
export const POST_WORKFLOW_ENABLED_FOR_ALL_ACCOUNTS = true;

/**
 * Whether the editorial post-workflow calls should hit the new API for the CURRENT account.
 * True when the full-cutover switch is on, or the live account id is allowlisted above.
 * The account id is read per call, so it follows account switching.
 */
export function isPostWorkflowApiNew(): boolean {
  if (POST_WORKFLOW_ENABLED_FOR_ALL_ACCOUNTS) {
    return true;
  }

  return isPostWorkflowNewApiAccountId(
    CognitoTokenManager.getSelectedAccountId(),
  );
}

/** Whether the given account id is allowlisted for the new post-workflow API. */
export function isPostWorkflowNewApiAccountId(
  accountId: number | null | undefined,
): boolean {
  return (
    accountId != null && POST_WORKFLOW_NEW_API_ACCOUNT_IDS.includes(accountId)
  );
}
